import "./CommonPopup.scss";
import Button from "components/Button/Button";
import { useAppDispatch } from "store";

interface CommonPopupProps {
  onClick: () => void;
  header: string;
  desc?: string;
}

const CommonPopup = ({ onClick, header, desc }: CommonPopupProps) => {
  return (
    <div className="common-popup-container">
      <div className="common-popup">
        <div className="common-popup-content">
          <div className="common-popup-header">{header}</div>
          <div className="common-popup-desc">{desc}</div>
          <Button
            btnName={'Cancel'}
            className={"blue-btn"}
            onClick={onClick}
          />
        </div>
      </div>
    </div>
  );
};

export default CommonPopup;
